import { render, staticRenderFns } from "./Paap.vue?vue&type=template&id=57a16ac6"
import script from "./Paap.vue?vue&type=script&lang=js"
export * from "./Paap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports